export const managerialAccountsPtBr = {
  common: {
    save: 'Salvar',
    saving: 'Salvando...',
    cancel: 'Cancelar',
  },
  errors: {
    loadAccounts: 'Erro ao carregar contas gerenciais',
    saveAccount: 'Não foi possível salvar a conta gerencial.',
    endDate: 'Não foi possível encerrar a vigência.',
    reactivate: 'Não foi possível reativar a conta gerencial.',
  },
  pages: {
    managerialAccounts: {
      title: 'Plano de contas gerencial',
      rollupsLink: 'Agrupamentos',
      integrationMapping: 'Mapeamento de integrações',
      confirmInactivate: 'Encerrar vigência da conta {{code}} — {{name}}?',
      inactivateDialogTitle: 'Confirmar encerramento',
      cancelButton: 'Cancelar',
      confirmButton: 'Encerrar',
    },
  },
  filters: {
    title: 'Filtros',
    entityLabel: 'Entidade',
    entityPlaceholderAll: 'Todas',
    searchPlaceholder: 'Buscar por código, nome...',
    visibilityPlaceholder: 'Visibilidade',
    status: {
      active: 'Apenas ativas',
      inactive: 'Apenas inativas',
      all: 'Todas as contas',
      ended: 'Vigência encerrada',
    },
    createRoot: 'Nova conta',
  },
  table: {
    empty: 'Nenhuma conta gerencial encontrada.',
    expandAll: 'Expandir tudo',
    collapseAll: 'Recolher tudo',
    headers: {
      account: 'Conta',
      code: 'Código',
      type: 'Tipo',
      status: 'Status',
      endDate: 'Vigência até',
      actions: 'Ações',
    },
    status: {
      active: 'Ativa',
      inactive: 'Inativa',
    },
    endDatePlaceholder: '—',
    descriptionPlaceholder: 'Sem descrição',
    actions: {
      addChild: 'Adicionar conta filha',
      edit: 'Editar conta',
      end: 'Encerrar vigência',
      reactivate: 'Reativar conta',
    },
    tooltips: {
      addChild: 'Adicionar filha',
      edit: 'Editar',
      end: 'Encerrar',
      reactivate: 'Reativar',
    },
    aria: {
      expand: 'Expandir',
      collapse: 'Recolher',
    },
  },
  form: {
    title: {
      create: 'Nova conta gerencial',
      edit: 'Editar conta gerencial',
    },
    validation: {
      entityRequired: 'Selecione uma entidade.',
      codeNameRequired: 'Preencha código e nome.',
      accountTypeRequired: 'Selecione o tipo de conta para contas raiz.',
    },
    fields: {
      parent: {
        label: 'Conta pai',
        placeholder: 'Sem conta pai',
      },
      accountType: {
        label: 'Tipo de conta',
        placeholder: 'Selecione o tipo',
      },
      code: {
        label: 'Código',
        placeholder: 'Ex: 1.01.001',
        validating: 'Validando código...',
      },
      name: {
        label: 'Nome',
        placeholder: 'Ex: Despesas com Pessoal',
      },
      description: {
        label: 'Descrição breve',
        placeholder: 'Ex: Gastos relacionados a folha de pagamento',
      },
      aiContext: {
        label: 'Contexto de IA',
        regenerate: 'Gerar novamente',
        regenerating: 'Gerando...',
        generating: 'Gerando sugestão com IA...',
        placeholder: 'Contexto adicional para categorização inteligente',
      },
      dates: {
        startLabel: 'Início da vigência',
        endLabel: 'Término da vigência',
      },
    },
    submit: {
      save: 'Salvar',
      saving: 'Salvando...',
    },
  },
  accountTypes: {
    ASSET: 'Ativo',
    LIABILITY: 'Passivo',
    EQUITY: 'Patrimônio líquido',
    REVENUE: 'Receita',
    COGS: 'Custo (CMV/CPV/CSP)',
    EXPENSE: 'Despesa',
    OTHER_INCOME: 'Outras receitas',
    OTHER_EXPENSE: 'Outras despesas',
  },
  accountTypeTabs: {
    ASSET: 'Ativo',
    LIABILITY: 'Passivo',
    EQUITY: 'PL',
    REVENUE: 'Receita',
    COGS: 'Custo',
    EXPENSE: 'Despesa',
    OTHER_INCOME: 'Outras Rec.',
    OTHER_EXPENSE: 'Outras Desp.',
  },
} as const;

export const managerialAccountsEn = {
  accountTypeTabs: {
    ASSET: 'Asset',
    LIABILITY: 'Liability',
    EQUITY: 'Equity',
    REVENUE: 'Revenue',
    COGS: 'COGS',
    EXPENSE: 'Expense',
    OTHER_INCOME: 'Other Inc.',
    OTHER_EXPENSE: 'Other Exp.',
  },
} as const;
